<template>
  <section>
    <search :searchStatus="false"></search>
    <section class="padding-footer">
      <div class="util-detail-header">
        <div class="util-header-top">
          <div>
            <img src="@/assets/img/util-tab-6-title.svg" />
          </div>
          <div class="util-detail-header-title">
            <strong>Tambah Pencatatan Pemakaian Sparepart</strong>
          </div>
        </div>
        <span>Masukkan Catatan Sesuai Form</span>
      </div>
      <div class="illusion"></div>
      <b-container>
        <section style="padding-inline: 12px; padding-top: 8px">
          <ValidationObserver ref="observer">
            <b-form
              slot-scope="{ validate }"
              @submit.prevent="validate().then(submitTicket)"
            >
              <div style="display: flex; flex-direction: column; gap: 8px">
                <ValidationProvider rules="required" name="Date">
                  <b-form-group slot-scope="{ valid, errors }" class="mb-1">
                    <b-form-input
                      class="txt-input2"
                      v-bind:class="{ active: isActive }"
                      placeholder="Tanggal Penggantian"
                      v-model="date"
                      :state="errors[0] ? false : valid ? true : null"
                      @focus="toDate"
                      @blur="toText"
                      type="text"
                    ></b-form-input>
                    <b-form-invalid-feedback id="inputLiveFeedback">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider rules="required" name="Division">
                  <b-form-group slot-scope="{ valid, errors }" class="mb-1">
                    <div class="box-select" v-bind:class="{ active: isActive }">
                      <img src="@/assets/img/icon-paper-coklat.svg" alt="" />
                      <b-form-select
                        v-model="division"
                        :options="opt_division"
                        class="select-option"
                        value-field="value"
                        text-field="text"
                        disabled-field="notEnabled"
                        :state="errors[0] ? false : valid ? true : null"
                        @change="getSpareparts"
                      ></b-form-select>
                    </div>
                    <b-form-invalid-feedback class="d-block" v-if="errors[0]">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider rules="required" name="Shift">
                  <b-form-group slot-scope="{ valid, errors }" class="mb-1">
                    <div class="box-select" v-bind:class="{ active: isActive }">
                      <img src="@/assets/img/icon-paper-coklat.svg" alt="" />
                      <b-form-select
                        v-model="shift"
                        :options="opt_shift"
                        class="select-option"
                        value-field="value"
                        text-field="text"
                        disabled-field="notEnabled"
                        :state="errors[0] ? false : valid ? true : null"
                      ></b-form-select>
                    </div>
                    <b-form-invalid-feedback class="d-block" v-if="errors[0]">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider
                  :rules="division !== 'project' ? 'required' : ''"
                  name="Mesin"
                >
                  <b-form-group slot-scope="{ valid, errors }" class="mb-1">
                    <div class="box-select" v-bind:class="{ active: isActive }">
                      <img src="@/assets/img/icon-paper-coklat.svg" alt="" />
                      <select-autocomplete
                        v-model="machine"
                        :list="opt_machine"
                        :placeholder="'Select Machine'"
                        :state="errors[0] ? false : valid ? true : null"
                        @change="getSparepart"
                      ></select-autocomplete>
                    </div>
                    <b-form-invalid-feedback class="d-block" v-if="errors[0]">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
                <!-- <ValidationProvider rules="required" name="Mesin">
                  <b-form-group slot-scope="{ valid, errors }" class="mb-1">
                    <div class="box-select" v-bind:class="{ active: isActive }">
                      <img src="@/assets/img/icon-paper-coklat.svg" alt="" />
                      <b-form-select
                        v-model="machine"
                        :options="opt_machine"
                        class="select-option"
                        value-field="value"
                        text-field="text"
                        disabled-field="notEnabled"
                        :state="errors[0] ? false : valid ? true : null"
                        @change="getSparepart"
                      ></b-form-select>
                    </div>
                    <b-form-invalid-feedback class="d-block" v-if="errors[0]">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider> -->
                <ValidationProvider
                  rules="required"
                  name="Spare Part"
                >
                  <b-form-group slot-scope="{ valid, errors }" class="mb-1">
                    <div class="box-select" v-bind:class="{ active: isActive }">
                      <img src="@/assets/img/icon-paper-coklat.svg" alt="" />
                      <select-autocomplete
                        v-model="sparepart"
                        :list="opt_sparepart"
                        :placeholder="'Select Sparepart'"
                        :state="errors[0] ? false : valid ? true : null"
                      ></select-autocomplete>
                    </div>
                    <b-form-invalid-feedback class="d-block" v-if="errors[0]">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>

                <ValidationProvider rules="required" name="Quantity">
                  <b-form-group slot-scope="{ valid, errors }" class="mb-1">
                    <b-form-input
                      class="txt-input1"
                      v-bind:class="{ active: isActive }"
                      placeholder="Quantity"
                      v-model="quantity"
                      :state="errors[0] ? false : valid ? true : null"
                      type="number"
                    ></b-form-input>
                    <b-form-invalid-feedback id="inputLiveFeedback">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>

                <ValidationProvider rules="required" name="Note">
                  <b-form-group slot-scope="{ valid, errors }" class="mb-1">
                    <b-form-textarea
                      id="textarea"
                      v-model="note"
                      placeholder="Note"
                      rows="2"
                      class="text-area2"
                      v-bind:class="{ active: isActive }"
                      :state="errors[0] ? false : valid ? true : null"
                    ></b-form-textarea>
                    <b-form-invalid-feedback id="inputLiveFeedback">
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </ValidationProvider>
              </div>
            </b-form>
          </ValidationObserver>
        </section>
      </b-container>
    </section>
    <util-action @submit="submit"></util-action>
    <!-- <MenuFooter /> -->
  </section>
</template>
<script lang="js">
import dayjs from "dayjs";
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import Search from "@/components/Search.vue";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import UtilAction from "@/views/pages/Utilities/Components/Util-Action.vue";
import { api } from "@/api/api";
import SelectAutocomplete from "@/components/input/SelectAutocomplete.vue";

@Component({
    components: {
        MenuFooter,
        Search,
        ValidationObserver,
        ValidationProvider,
        UtilAction,
        SelectAutocomplete,

    },
})
export default class Utilities extends Vue {
    isActive = false
    errors = []
    toDate(e) {
      e.target.type = 'date'
    }
    toText(e) {
      if(!e.target.value){
        e.target.type = 'text'
      }
    }

    opt_division = []
    opt_shift = []
    opt_machine = []
    opt_sparepart = []

    date = dayjs().format("YYYY-MM-DD")
    division = null
    shift = null
    machine = null
    sparepart = null
    quantity = null
    note = null
    total = 0

    mounted() {
      this.getDivision()
      this.getShift()
      this.getMachine()
      this.opt_sparepart = [{value:null,text:"Select Sparepart"}]
    }

    getDivision() {
      api('division_option').then(res => {
        if (res.code == 200) {
          this.opt_division = [{value: null, text: 'Select Division'}, ...res.data.map(item => {
            return {
              value: item.id,
              text: item.label
            }
          })]
        }
      })
    }

    getShift() {
      api('shift_option').then(res => {
        if (res.code == 200) {
          this.opt_shift = [{value:null,text:"Select Shift"}, ...res.data.map(item => {
            return {
              value: item.id,
              text: item.label
            }
          })]
        }
      })
    }

    getMachine() {
      api('machine_option').then(res => {
        if (res.code == 200) {
          this.opt_machine = [{value:null,text:"Select Machine"}, ...res.data.map(item => {
            return {
              value: ""+item.id,
              text: item.name
            }
          })]
        }
      })
    }
    getSpareparts(){
      if(this.division == 'project'){
        this.getSparepart()
      }
    }
    getSparepart() {
      if(this.machine) {
        api('sparepart_option',{params:{machine_id:this.machine}}).then(res => {
          if (res.code == 200) {
            this.opt_sparepart = [{value:null,text:"Select Sparepart"}, ...res.data.map(item => {
              return {
                value: ""+item.id,
                text: item.item_name
              }
            })]
          }
        })
      }else{
        api('sparepart_option').then(res => {
          if (res.code == 200) {
            this.opt_sparepart = [{value:null,text:"Select Sparepart"}, ...res.data.map(item => {
              return {
                value: ""+item.id,
                text: item.item_name
              }
            })]
          }
        })
      }
    }
    @Watch('machine')
    onStateChange() {
      this.getSparepart()
    }
    submit(){
      if (this.date && this.division && this.shift && this.quantity && this.sparepart ) {
        if (this.division === 'maintenance' && !this.machine) {
          this.$swal("Error", "Mesin wajib diisi", "error");
          return;
        }
        if (this.quantity < 1 ) {
          this.$swal("Error", "Quantity harus lebih dari 0", "error");
          return;
        }
        let data = {
            "usage_date" : this.date,
            "division" : this.division,
            "shift" : this.shift,
            "machines_id" : this.machine,
            "ref_spareparts_id" : this.sparepart,
            "qty" : this.quantity,
            "note" : this.note,
        }
        api('sparepart_add',{body:data}).then(res => {
          if (res.code == 200) {
            this.$router.push('/sparepart')
          } else {
          this.$swal("Peringatan", res.data.message, "warning");
        }
      })
      .catch((err) => {
        this.$swal("Error", err?.response?.data?.message, "error");
      });
      }else{
      this.$swal("Error", "Semua field wajib diisi, kecuali mesin untuk divisi projek", "error");
    }
    }
}
</script>
<style>
.box-select input {
  margin-top: -8px !important;
  padding-inline: 0 !important;
}
</style>
